import React, { useEffect, useState } from 'react'
import { axiosapi } from '../../api/axiosapi';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

const OperatorList = () => {
    const axiosPrivate = useAxiosPrivate();
    const [operatorList, setoperatorList] = useState([]);
    const [requestStatus, setRequestStatus] = useState();
    const handleChange = async (event, operatorid) => {
        event.preventDefault();
        setRequestStatus(event.target.value)
        const response = await axiosPrivate.post("/operator/updateoperatorstatus", { status: event.target.value, operatorid: operatorid })
        console.log(response.data)
    }
    useEffect(() => {
        const getOperators = async () => {
            const response = await axiosPrivate.get('/operator');
            setoperatorList(response.data.operator);


        }
        getOperators();
    }, [])
    useEffect(() => {
        const getOperators = async () => {
            const response = await axiosPrivate.get('/operator');
            setoperatorList(response.data.operator);


        }
        getOperators();
    }, [requestStatus])

    return (
        <div className='px-4 pt-1'>
            <p className="font-bold text-center text-xl mt-5 mb-5">Operator List</p>
            <div className='font-bold mt-2  flex  gap-1  items-center justify-between border-b-2 p-1  '>
                <p className='w-[35%]  text-center  '>User Id</p>
                <p className='w-[25%] text-center'>Name</p>
                <p className='w-[25%] text-center'>Licence Number</p>
                <p className='w-[25%] text-center'>Address</p>
                <p className='w-[30%] text-center'>Email</p>
                <p className='w-[20%] text-center'>Status</p>
                <p className='w-[25%] text-center'>Change Status</p>

            </div>
            {operatorList.map((operator) => (
                <div className='flex mt-2  gap-1 items-center justify-between border-b-2 p-1 '>
                    <p className='w-[35%] text-center  flex-wrap '>{operator.userId}</p>
                    <p className='w-[25%] text-center flex-wrap'>{operator.name}</p>
                    <p className='w-[25%] text-center flex-wrap'>{operator.operatorLicenceNumber}</p>
                    <p className='w-[25%] text-center flex-wrap'>{operator.address}</p>
                    <p className='w-[30%]  text-center flex-wrap'>{operator.email}</p>
                    <p className='w-[20%] text-center flex-wrap'>{operator.requestStatus}</p>
                    <select
                        className="w-[25%]"
                        id="requestStatus"
                        value={requestStatus}
                        onChange={(event) => handleChange(event, operator._id)}
                    >
                        <option value="">--Please choose an option--</option>
                        <option value="Pending">Pending</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                    </select>

                </div>
            ))
            }


        </div >
    )
}

export default OperatorList;
